import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgGraySum = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={50}
    height={50}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <circle cx={25} cy={25} r={25} fill="#E5EBF0" />
    <path
      d="M29.792 31.823h-9.584c-.312 0-.573-.156-.677-.417-.156-.26-.104-.573.104-.833l4.427-5.677-4.375-5.417c-.208-.208-.208-.573-.104-.833.105-.26.417-.469.73-.469h9.479a.8.8 0 0 1 .78.781v2.76a.801.801 0 0 1-.78.782.801.801 0 0 1-.782-.781v-1.98h-7.135l3.75 4.636c.208.26.208.677 0 .99l-3.854 4.895h7.24v-1.823c0-.416.364-.78.78-.78.417 0 .782.364.782.78v2.605a.767.767 0 0 1-.781.78Z"
      fill="#13273F"
    />
    <path
      d="M25 40c-8.281 0-15-6.719-15-15 0-8.281 6.719-15 15-15 8.281 0 15 6.719 15 15 0 8.281-6.719 15-15 15Zm0-28.438c-7.396 0-13.438 6.042-13.438 13.438 0 7.396 6.042 13.438 13.438 13.438 7.396 0 13.438-6.042 13.438-13.438 0-7.396-6.042-13.438-13.438-13.438Z"
      fill="#13273F"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgGraySum);
export default ForwardRef;
